import React from 'react';
import styled from 'styled-components';
import { EventPageContextProvider } from 'src/modules/events/components/EventPage/EventPageContext';
import { EventPageHeaderSection } from 'src/modules/events/components/EventPage/EventPageHeaderSection';
import { EventPageAboutSection } from 'src/modules/events/components/EventPage/EventPageAboutSection';
import { EventPageHowToParticipate } from 'src/modules/events/components/EventPage/EventPageHowToParticipate';
import { EventPageVideoPlayer } from 'src/modules/events/components/EventPage/EventPageVideoPlayer';
import { EventPageSpeakersSection } from 'src/modules/events/components/EventPage/EventPageSpeakersSection';
import { EventPageRelatedVideosSection } from 'src/modules/events/components/EventPage/EventPageRelatedVideosSection';
import { EventPageFAQSection } from 'src/modules/events/components/EventPage/EventPageFAQSection';
import { EventPageAgendaSection } from 'src/modules/events/components/EventPage/EventPageAgendaSection';
import { EventPageSection } from 'src/modules/events/models/eventPage';
import { EventPageSEO } from 'src/modules/events/components/EventPage/EventPageSEO';
import { StickyMenuProvider } from 'src/components/common/StickyMenu/StickyMenuContext';
import { StickyMenuSection } from 'src/components/common/StickyMenu/StickyMenuSection';
import { EventPageHeaderPlaceholder } from 'src/modules/events/components/EventPage/EventPageHeaderSection/EventPageHeaderPlaceholder';
import { useEventDetailsQuery } from 'src/modules/events/hooks/useEventDetailsQuery';

export interface EventPageTemplateProps {
  slug: string;
}

const OrderContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const EventPageTemplate = ({ slug }: EventPageTemplateProps) => {
  const { data: event, isLoading } = useEventDetailsQuery(slug);

  if (!event || isLoading) {
    return <EventPageHeaderPlaceholder />;
  }

  return (
    <EventPageContextProvider event={event}>
      <StickyMenuProvider>
        <EventPageSEO event={event} />

        <StickyMenuSection id={EventPageSection.About} threshold={0.2}>
          <EventPageHeaderSection />

          <OrderContainer>
            <EventPageAboutSection />
            <EventPageHowToParticipate />
            <EventPageVideoPlayer />
          </OrderContainer>
        </StickyMenuSection>

        <StickyMenuSection id={EventPageSection.Agenda} threshold={0.5}>
          <EventPageAgendaSection />
        </StickyMenuSection>

        <StickyMenuSection id={EventPageSection.Speakers} threshold={0.5}>
          <EventPageSpeakersSection />
        </StickyMenuSection>

        <StickyMenuSection id={EventPageSection.RelatedVideos} threshold={0.75}>
          <EventPageRelatedVideosSection />
        </StickyMenuSection>

        <StickyMenuSection id={EventPageSection.FAQ} threshold={0.2}>
          <EventPageFAQSection />
        </StickyMenuSection>
      </StickyMenuProvider>
    </EventPageContextProvider>
  );
};
